import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import config from '../../config';

function AdminLogin() {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await fetch(`${config.API_BASE}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await response.json();
      if (data.token && data.user) {
        if (data.user.role === 'admin') {
          localStorage.setItem('adminToken', data.token);
          history.push('/admin/messages');
        } else {
          setError('You are not an admin.');
        }
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      setError('Login failed');
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="xs" style={{ marginTop: 80, background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(21,28,67,0.06)', padding: 32 }}>
      <Typography variant="h5" align="center" gutterBottom>Admin Login</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          margin="normal"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <TextField
          label="Password"
          variant="outlined"
          fullWidth
          margin="normal"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        {error && <Typography color="error" align="center">{error}</Typography>}
        <Box mt={2}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </Box>
      </form>
    </Container>
  );
}

export default AdminLogin; 